var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZumAbsaeuernVonMetallen = function SvgZumAbsaeuernVonMetallen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Zum_Absaeuern_von_Metallen_svg__Ebene_2",
    viewBox: "0 0 113.02 86.59"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Zum_Absaeuern_von_Metallen_svg__cls-1{stroke-width:2.4px;fill:none;stroke:currentColor;stroke-miterlimit:10}"))), /*#__PURE__*/React.createElement("g", {
    id: "Zum_Absaeuern_von_Metallen_svg__Layer_1"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57.86,
    cy: 11.99,
    r: 8.15,
    className: "Zum_Absaeuern_von_Metallen_svg__cls-1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.17,
    cy: 25.84,
    r: 5.94,
    className: "Zum_Absaeuern_von_Metallen_svg__cls-1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.3,
    cy: 8.25,
    r: 7.05,
    className: "Zum_Absaeuern_von_Metallen_svg__cls-1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.28,
    cy: 25.64,
    r: 4.62,
    className: "Zum_Absaeuern_von_Metallen_svg__cls-1"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.72,
    cy: 31.41,
    r: 8.15,
    className: "Zum_Absaeuern_von_Metallen_svg__cls-1"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.81,
    cy: 31.86,
    r: 7.05,
    className: "Zum_Absaeuern_von_Metallen_svg__cls-1"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.17,
    cy: 10.26,
    r: 4.62,
    className: "Zum_Absaeuern_von_Metallen_svg__cls-1"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.88,
    cy: 9.5,
    r: 7.05,
    className: "Zum_Absaeuern_von_Metallen_svg__cls-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m56.43 27.45 53.92 28.8-54.8 28.92-52.92-29.8z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeMiterlimit: 10,
      strokeWidth: "2.5px"
    }
  })));
};
export default SvgZumAbsaeuernVonMetallen;